<template>
  <div>
    <el-form
      ref="lxpsForm"
      :rules="rules"
      label-width="0px"
      :hide-required-asterisk="false"
    >
      <div class="card">
        <el-row>
          <el-col :span="24" class="label"> {{ baseInfo.courseName }} </el-col>
        </el-row>
        <div class="card_content">
          <div>
            <el-button type="primary" size="small" @click="handleToZqjcsq()"
              >查看中期检查申请</el-button
            >
          </div>
          <div>
            <span>课题编号:</span>
            <span>{{ baseInfo.courseId }}</span>
          </div>
          <div>
            <span>课题负责人:</span>
            <span>{{ baseInfo.courseLeaderName }}</span>
          </div>
          <div>
            <span>课题主要成员:</span>
            <span>{{ baseInfo.memberName }}</span>
          </div>
          <el-row>
            <el-col :span="12" v-if="user.courseAdmin == 1">
              <div>
                <span style="margin-right: 30px">是否管理组录入结果:</span>
                <span>
                  <el-radio-group
                    v-model="isSystemGroup"
                    @change="handleChangeSystemGroup"
                  >
                    <el-radio label="1">是 </el-radio>
                    <el-radio label="0">否 </el-radio>
                  </el-radio-group>
                </span>
              </div>
            </el-col>
            <el-col :span="12" v-show="isSystemGroup == 1">
              <div>
                <span style="margin-right: 30px">评审委员:</span>
                <span>
                  <el-select
                    v-model="judgeser"
                    placeholder="请选择评审委员"
                    clearable
                    filterable
                    size="small"
                    style="width: 200px"
                    class="filter-item"
                    @change="handleChangeJudgeser"
                  >
                    <el-option
                      v-for="item in zjwyhList"
                      :key="item.judgeser"
                      :label="item.judges"
                      :value="item.judgeser"
                    />
                  </el-select>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="card">
        <div class="title">
          <div>
            中期检查情况(课题研究进展情况：请根据立项申请表中的时间计划安排，说明任务完成情况)
          </div>
          <div>
            <el-button type="primary" size="small" @click="handleToResult()"
              >附件查看</el-button
            >
          </div>
        </div>
        <div class="table">
          <el-table
            :max-height="height"
            :data="zqjcList"
            fit
            highlight-current-row
            :default-sort="{ prop: 'date', order: 'descending' }"
            tooltip-effect="dark"
          >
            <el-table-column
              label="时间计划"
              align="left"
              prop="planTime"
              min-width="80px"
              :show-overflow-tooltip="true"
            />

            <el-table-column
              label="任务内容"
              align="left"
              prop="taskContent"
              min-width="120px"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              label="进展情况"
              align="left"
              prop="progress"
              min-width="80px"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              label="备注"
              align="left"
              prop="remark"
              min-width="120px"
              :show-overflow-tooltip="true"
            />
            <template slot="empty">
              <div class="nodata">
                <img src="@/img/nodata.png" alt="" width="160" />
                <div>暂无数据</div>
              </div>
            </template>
          </el-table>
          <pagination
            v-show="zqjcList.length > 0"
            :total="zqjcList.length"
            :page.sync="zqjcParams.page"
            :limit.sync="zqjcParams.pageSize"
            @pagination="getZqjcjdqk"
          />
        </div>
      </div>
      <div
        class="card card3"
        v-if="baseInfo.metaPropList && baseInfo.metaPropList.length > 0"
      >
        <el-row>
          <el-col :span="24" class="title"> 研究方案 </el-col>
        </el-row>
        <el-row style="margin: 0 30px">
          <el-col
            :span="24"
            v-for="(item, index) in baseInfo.metaPropList"
            :key="index"
          >
            <div class="card3_label">
              <span v-if="item.required == '1'" class="red_label">*</span>
              <span>{{ item.cname }}</span>
            </div>
            <div :id="'wangEditor_zqjc_form' + index"></div>
          </el-col>
        </el-row>
      </div>
      <div class="card card4">
        <div class="result">
          <div class="title">专家委员会意见</div>
          <div>
            <div style="margin: 0 30px">
              <div id="userExpertOpinion"></div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <el-dialog
      title="添加进展情况"
      :visible.sync="addDialog"
      width="700px"
      v-if="addDialog"
      append-to-body
      :closeOnClickModal="false"
    >
      <AddProgress
        ref="addProgress"
        @getParentForm="getData"
        :mxParams="mxParams"
      ></AddProgress>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleAddProgress">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑进展情况"
      :visible.sync="editDialog"
      width="700px"
      v-if="editDialog"
      append-to-body
      :closeOnClickModal="false"
    >
      <EditProgress
        ref="editProgress"
        :mxParams="mxParams"
        :editForm="editForm"
        @getParentForm="getData"
      ></EditProgress>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleEditProgress">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import wangEditor from "wangeditor";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";
import { mapGetters } from "vuex";
import AddProgress from "./addProgress.vue";
import EditProgress from "./editProgress.vue";
import {
  getMidCheckForm,
  getCourseSituation,
  delSituation,
  insertCheckSuggest,
} from "@/api/course.js";
import Pagination from "@/components/Pagination";

export default {
  components: {
    Treeselect,
    AddProgress,
    EditProgress,
    Pagination,
  },
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  props: ["mxParams"],
  data() {
    return {
      addDialog: false,
      editDialog: false,
      baseInfo: {
        metaPropList: [],
      },
      height: 500,
      rules: {},
      cyList: [
        {
          name: "",
        },
      ],

      editor: [],
      zqjcList: [],
      zqjcListCount: 0,
      zqjcParams: {
        page: 1,
        pageSize: 10,
      },
      editForm: {},
      feedbackList: [],
      zjwyhList: [], //专家委员会意见
      isSystemGroup: "1",
      userExpertOpinion: "",
      judgeser: null,
      userExpertOpinionEditor: null,
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    const timer = setInterval(() => {
      if (this.baseInfo.metaPropList && this.baseInfo.metaPropList.length > 0) {
        for (let i in this.baseInfo.metaPropList) {
          let editor = new wangEditor(`#wangEditor_zqjc_form${i}`);
          editor = this.editorConfig(editor);
          editor.disable();
          editor.txt.html(this.baseInfo.metaPropList[i].propValue);
          this.editor.push(editor);
          document.querySelector(
            `#wangEditor_zqjc_form${i} .w-e-text-container`
          ).style.backgroundColor = "#f3f3f3";
          document.querySelector(
            `#wangEditor_zqjc_form${i} .w-e-toolbar`
          ).style.backgroundColor = "#f3f3f3";
        }
        let editor = new wangEditor(`#userExpertOpinion`);
        this.userExpertOpinionEditor = this.editorConfig(editor);
        this.userExpertOpinionEditor.txt.html(this.userExpertOpinion);
        clearInterval(timer);
      }
    }, 50);
  },

  methods: {
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中
      // editor.config.onchange = function () {
      //   if (editor.txt.html() == "") {
      //     editor.txt.html("&nbsp");
      //   }
      // };

      editor.create();
      return editor;
    },
    getData() {
      this.addDialog = false;
      this.editDialog = false;
      const courseId = this.mxParams.id;
      getMidCheckForm({ courseId }).then((res) => {
        if (res.code == 0) {
          this.baseInfo = res.data.midCheckInfo;
          this.feedbackList = [res.data.feedback];
          this.isSystemGroup = res.data.isSystemGroup + "";
          this.zjwyhList = res.data.allExpertOpinion;
          this.userExpertOpinion = res.data.userExpertOpinion;
        }
      });
      this.getZqjcjdqk();
    },
    //中期检查进度情况
    getZqjcjdqk() {
      const { page, pageSize } = this.zqjcParams;
      getCourseSituation({ page, pageSize, courseId: this.mxParams.id }).then(
        (res) => {
          if (res.code == 0) {
            this.zqjcList = res.data;
            this.zqjcListCount = res.count;
          }
        }
      );
    },

    delSituationItem(row) {
      delSituation({ id: row.id }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getData();
        }
      });
    },
    editCy(row) {
      this.editDialog = true;
      this.mxParams.id = row.id;
    },

    handleAddProgress() {
      this.$refs.addProgress.save();
      this.getData();
    },
    handleEditProgress() {
      this.$refs.editProgress.save();
      this.getData();
    },
    handleEditOpen(row) {
      this.editForm = row;
      this.editDialog = true;
    },
    saveForm() {
      if (
        !this.baseInfo.judgeser &&
        this.isSystemGroup == "1" &&
        this.user.courseAdmin == 1
      ) {
        this.$message.error("请选择评审委员!");
        return;
      }
      if (this.isSystemGroup == "2") {
        this.baseInfo.judgeser = "";
        this.userExpertOpinion = "";
        this.userExpertOpinionEditor.txt.html("");
        insertCheckSuggest({
          ...this.baseInfo,
          manageGroup: this.isSystemGroup,
          expertOpinion: "",
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.$emit("getParentForm");
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        const expertOpinion = this.userExpertOpinionEditor.txt.html();
        insertCheckSuggest({
          ...this.baseInfo,
          manageGroup: this.isSystemGroup,
          expertOpinion,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.$emit("getParentForm");
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    handleChangeJudgeser(e) {
      for (let i in this.zjwyhList) {
        if (this.zjwyhList[i].judgeser == e) {
          this.userExpertOpinion = this.zjwyhList[i].advice1;
          this.userExpertOpinionEditor.txt.html(this.userExpertOpinion);
          this.baseInfo.judgeser = this.zjwyhList[i].judgeser;
        }
      }
    },
    handleChangeSystemGroup(e) {
      if (e == 0) {
        this.baseInfo.judgeser = null;
        this.userExpertOpinionEditor.txt.html("");
        this.userExpertOpinion = null;
        this.judgeser = null;
      }
    },
    handleToZqjcsq() {
      let routeUrl = this.$router.resolve({
        path: `/course/zqjcsqResult`,
        query: { id: this.mxParams.id, id: this.mxParams.id },
      });
      // this.$router.push({
      //   path: `/course/zqjcsqResult`,
      //   query: { id: this.mxParams.id, id: this.mxParams.id },
      // });
      window.open(routeUrl.href, "_blank");
    },
    handleToResult() {
      this.mxParams.flieStep = "4";
      let routeUrl = this.$router.resolve({
        name: `courseResult`,
      });
      localStorage.setItem("mxParams", JSON.stringify(this.mxParams));
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.card {
  //   border-bottom: 2px solid #f3f3f3;
  .label {
    font-size: 16px;
    font-weight: bold;
    height: 44px;
    line-height: 44px;
    padding-left: 15px;
  }
  .card_content {
    padding: 0 30px;
    > div {
      height: 42px;
      line-height: 42px;
      > span:nth-of-type(1) {
        margin-right: 30px;
      }
    }
  }
}
.card:nth-of-type(1) {
  margin-top: 0;
}
.result_content {
  border: 1px solid #ddd;
  line-height: 32px;
  .label {
    line-height: 42px;
    font-size: 16px;
    background-color: #f3f3f3;
    padding-left: 15px;
  }
  .text {
    padding: 15px;
  }
}
.title {
  font-size: 15px;
  font-weight: bold;
  padding-left: 15px;
  line-height: 42px;
  height: 42px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
}
.table_count {
  color: #666;
  margin: 10px 15px;
}
.result {
  margin-bottom: 15px;
  .result_detail {
    font-size: 14px;
    background: #f3f3f3;
    line-height: 32px;
    padding-left: 15px;
    margin: 0 15px;
    color: #666;
  }
}
.content {
  margin-bottom: 30px;
  .content_item {
    line-height: 32px;
    font-size: 14px;
    margin-bottom: 15px;
    .content_title {
      font-weight: 700;
    }
    .content_text {
      background-color: #f3f3f3;
      padding: 5px 15px;
      margin-right: 15px;
    }
  }
}
.table {
  margin: 0 30px;
}
.card3 {
  .card3_label {
    height: 44px;
    line-height: 44px;
    font-weight: bold;
    font-size: 15px;
  }
}
.red_label {
  color: #ff0000;
  margin-right: 5px;
}
</style>